import type { LessonStage } from '../../shared/types.ts';
import { formatEquation } from '../../shared/algebra.ts';
import { speakMath } from '../../shared/tutorGuidance.ts';

export const storyFor = (stage: LessonStage) =>
  stage.story ?? {
    initialLabel: 'starting charge',
    rateLabel: 'hourly rate',
    totalLabel: 'receipt total',
    unknownLabel: 'hours rented',
    unitLabel: 'hours',
    countUnit: 'dollars',
    theme: 'rental',
  };
export function storyFacts(stage: LessonStage) {
  const story = storyFor(stage),
    eq = stage.initialEquation;
  const labels = [story.initialLabel, story.rateLabel, story.totalLabel];
  return [eq.left.constant, eq.left.x, eq.right.constant].map((value, i) => ({
    value,
    label: labels[i],
    display:
      story.countUnit === 'dollars'
        ? `$${value}`
        : `${value} ${story.countUnit}`,
  }));
}
export function storyModelNarration(stage: LessonStage) {
  const story = storyFor(stage),
    facts = storyFacts(stage),
    eq = stage.initialEquation;
  return `Let's build this story. Let x mean ${story.unknownLabel}. The ${story.initialLabel} is ${facts[0].value} ${story.countUnit}, counted once. The ${story.rateLabel} is ${facts[1].value} ${story.countUnit} for each of the ${story.unitLabel}. So ${eq.left.x} times x represents the repeated quantity. Add ${eq.left.constant} to that repeated quantity. Together, ${speakMath(formatEquation(eq))}. Explain how each part matches the story.`;
}
